// Pure authentication business logic (no React dependencies)
export class AuthService {
    baseUrl;
    constructor(baseUrl = "/api") {
        this.baseUrl = baseUrl;
    }
    /**
     * Send OTP to phone number
     */
    async sendOTP(phoneNumber) {
        const response = await fetch(`${this.baseUrl}/auth/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ phoneNumber }),
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || "Failed to send OTP");
        }
        return await response.json();
    }
    /**
     * Verify OTP and authenticate user
     */
    async verifyOTP(phoneNumber, code) {
        const response = await fetch(`${this.baseUrl}/auth/verify`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ phoneNumber, code }),
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || "Failed to verify OTP");
        }
        return await response.json();
    }
    /**
     * Get current user info
     */
    async getCurrentUser(token) {
        const response = await fetch(`${this.baseUrl}/auth/me`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || "Failed to get user info");
        }
        return await response.json();
    }
    /**
     * Logout user
     */
    async logout(token) {
        const response = await fetch(`${this.baseUrl}/auth/logout`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || "Failed to logout");
        }
    }
    /**
     * Store session token securely
     */
    storeToken(token) {
        localStorage.setItem("auth_token", token);
    }
    /**
     * Get stored session token
     */
    getToken() {
        return localStorage.getItem("auth_token");
    }
    /**
     * Remove stored session token
     */
    removeToken() {
        localStorage.removeItem("auth_token");
    }
    /**
     * Check if user is authenticated
     */
    isAuthenticated() {
        const token = this.getToken();
        return !!token;
    }
}
